import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import TextField from '../../../../../components/TextField';
import MainCard from "../../../../../components/MainCard"

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { useAuth } from '../../../../../context/auth';
import { showMessage } from '../../../../../helpers/message';
import { getSessionCookie } from '../../../../../helpers/cookies';

//API
import diasNaoUteis_api from '../../../../../api/diasNaoUteis_api';

function initialStateDiasNaoUteis(secretaria_Id) {
    return {
        descricao: "",
        diaMes: null,
        excluido: false,
        secretaria_Id: secretaria_Id
    }
}

function CadastroDiaNaoUteis({ id, handleVoltar, editavel = false }) {
    //Dados de autenticação
    const session = getSessionCookie();

    //State para criar/editar
    const [diaNaoUteis, setDiasNaoUteis] = useState(initialStateDiasNaoUteis(session.secretaria_Id));

    //State para pegar erros
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    //Função para pegar lista de dias não uteis
    const loadDiaNaoUtel = (id) => {
        if (id != null) {
            setLoading(true);
            diasNaoUteis_api.getItem(id).then(response => {
                const dataValor = new Date();
                dataValor.setDate(parseInt(response.data.diaMes.split("/")[0]));
                dataValor.setMonth(parseInt(response.data.diaMes.split("/")[1]) - 1);
                response.data.diaMes = moment(dataValor).format();
                setDiasNaoUteis(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }


    useEffect(() => {
        loadDiaNaoUtel(id);
    }, []);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "diaMes", required: true })
    ];

    //Função para modificar state
    const onChange = (e) => {
        const { name, value } = e.target;
        const _diaNaoUteis = {
            ...diaNaoUteis,
            [name]: value
        };

        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_diaNaoUteis, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setDiasNaoUteis(_diaNaoUteis);
    };

    //Função para modificar state de data
    const handleDateChange = (date) => {
        const _diaNaoUteis = {
            ...diaNaoUteis
        };
        _diaNaoUteis.diaMes = moment(date).format();

        const _campos = campos.filter(campo => campo.name == "diaMes");
        const fieldError = validarCampos(_diaNaoUteis, _campos);

        const _errors = { ...errors };
        delete _errors["diaMes"];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setDiasNaoUteis(_diaNaoUteis);
    };

    //Função para salvar dia não util
    const salvaDiasNaoUteis = () => {
        const _errors = validarCampos(diaNaoUteis, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        if (diaNaoUteis.id) {
            setLoading(true);
            const _diaNaoUteis = {
                ...diaNaoUteis,
                diaMes: moment(diaNaoUteis.diaMes).format("DD/MM")
            }
            diasNaoUteis_api.put(_diaNaoUteis)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", handleVoltar)
                })
                .catch(err => showMessage("Error", err.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            const _diaNaoUteis = {
                ...diaNaoUteis,
                diaMes: moment(diaNaoUteis.diaMes).format("DD/MM")
            }
            diasNaoUteis_api.post(_diaNaoUteis)
                .then(response => {
                    showMessage("Aviso", "Operação realizada com sucesso", "success", handleVoltar)
                })
                .catch(err => showMessage("Error", err.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Button onClick={() => {
            handleVoltar()
        }} className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <h5 style={{ color: "#666" }}>Cadastro de Dias não Úteis</h5>
            <Row className=''>
                <Col md={12} lg={8}>
                    <TextField
                        name={"descricao"}
                        label={"* Descrição"}
                        type={"text"}
                        value={diaNaoUteis.descricao}
                        onChange={onChange}
                        maxLength={100}
                        invalid={errors.descricao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"diaMes"}
                        label={"* Dia/Mês"}
                        type={"datePicker"}
                        value={diaNaoUteis.diaMes ? new Date(diaNaoUteis.diaMes) : null}
                        onChange={handleDateChange}
                        invalid={errors.diaMes}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                    <Button
                        className='px-4'
                        color={diaNaoUteis.id ? 'warning text-white' : 'success'}
                        onClick={salvaDiasNaoUteis}>{diaNaoUteis.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}

export default CadastroDiaNaoUteis;